import React from 'react';
import { Typography, Button, CircularProgress } from '@material-ui/core';
import { PLANNER_COLORS, tint } from '../../shared_components';
import { RADIUS, SPACE, TEXT } from '../../shared_components';

const LEVEL_COLOR = { escalated: PLANNER_COLORS.red, notified: PLANNER_COLORS.orange };
const LEVEL_ICON = { escalated: '🔴', notified: '⏳' };

const bannerNote = (banner) => (
  banner?.type === 'escalated'
    ? 'Admin has been notified.'
    : banner?.hours_until_escalation != null
      ? `Escalation in ~${banner.hours_until_escalation}h if no activity.`
      : ''
);

const InactivityBanners = ({ banners = [], onResolve, resolvingSlug }) => (
  <div style={{ marginBottom: '5px' }}>
    {(banners || []).map((banner) => (
      <div
        key={banner?.plan_slug}
        style={{
          display: 'flex', alignItems: 'center', gap: SPACE.sm, padding: '10px 16px', marginBottom: SPACE.sm,
          borderRadius: RADIUS, backgroundColor: tint(LEVEL_COLOR[banner?.type]), border: `1px solid ${LEVEL_COLOR[banner?.type]}40`,
        }}
      >
        <span style={{ fontSize: 15 }}>{LEVEL_ICON[banner?.type]}</span>
        <Typography variant="body2" style={{ color: TEXT.primary, flex: 1 }}>
          <strong>{banner?.type === 'escalated' ? 'Escalated' : 'Lead Notified'} — {banner?.plan_name} ({banner?.hours_inactive}h)</strong> — {bannerNote(banner)}
        </Typography>
        <Button
          size="small" variant="outlined"
          disabled={resolvingSlug === banner?.plan_slug}
          onClick={() => onResolve(banner?.plan_slug)}
        >
          {resolvingSlug === banner?.plan_slug ? <CircularProgress size={14} /> : 'Resolve'}
        </Button>
      </div>
    ))}
  </div>
);

export default InactivityBanners;
